import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { ConversationsTablePreviewButton } from './components/previewButton/conversationsTablePreviewButton';
import { ConversationsTableRowMenu } from './components/rowMenu/conversationsTableRowMenu';
/** Represents the content of the actions cell in the conversations table. */
export const ConversationsTableActions = () => {
    return (_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "100", justifyContent: "flex-end" }, { children: [_jsx(ConversationsTablePreviewButton, {}), _jsx(ConversationsTableRowMenu, {})] })));
};
